import React, { useEffect, useState } from "react";
import { Settings } from "lucide-react";
import AppLayout from "../components/AppLayout";
import { api } from "../lib/api";
import { toast } from "sonner";
import CompanionProfileSettings from "../components/CompanionProfileSettings";
import CompanionEnquiriesTable from "../components/CompanionEnquiriesTable";
import CompanionAvailability from "../components/CompanionAvailability";

export default function CompanionBookingsAdmin() {
  const [activeTab, setActiveTab] = useState("bookings");
  const [profileSettings, setProfileSettings] = useState({ profile_attrs: {}, services_offered: [], fetishes_offered: [], gallery_photos: [] });
  const [settingsLoading, setSettingsLoading] = useState(false);
  useEffect(() => {
    let mounted = true;
    api.get("/api/landing/config").then(({ data }) => {
      if (mounted) setProfileSettings({
        ...data, profile_attrs: data.profile_attrs || {}, services_offered: data.services_offered || [],
        fetishes_offered: data.fetishes_offered || [],
        gallery_photos: (data.gallery_photos || []).map((photo, order) => ({ order, ...photo })),
      });
    }).catch(() => { if (mounted) toast.error("Unable to load profile settings"); });
    return () => { mounted = false; };
  }, []);
  const saveProfileSettings = async () => {
    setSettingsLoading(true);
    try {
      await api.put("/api/landing/config", profileSettings, { _noOfflineQueue: true });
      toast.success("Escort companion settings saved successfully!");
    } catch { toast.error("Failed to save settings"); }
    finally { setSettingsLoading(false); }
  };
  const updateProfileAttr = (key, value) => setProfileSettings((current) => ({ ...current, profile_attrs: { ...current.profile_attrs, [key]: value } }));
  const toggle = (key, value) => setProfileSettings((current) => ({ ...current, [key]: current[key].includes(value) ? current[key].filter((item) => item !== value) : [...current[key], value] }));
  return <AppLayout title="Companion Bookings"><div className="p-4 text-white sm:p-6">
    <h1 className="text-3xl font-bold">Companion Enquiries</h1><p className="mt-2 text-sm text-zinc-300">Manage private availability enquiries and companion profile settings.</p>
    <div className="mb-6 mt-6 flex gap-4 border-b border-white/10">{[["bookings", "Enquiries"], ["settings", "Escort Companion"]].map(([id, title]) => <button key={id} type="button" onClick={() => setActiveTab(id)} aria-pressed={activeTab === id} className={`inline-flex min-h-12 items-center gap-2 border-b-2 px-3 text-sm ${activeTab === id ? "border-pink-400 text-pink-200" : "border-transparent text-zinc-300"}`}>{id === "settings" && <Settings size={16} />}{title}</button>)}</div>
    {activeTab === "bookings" ? <><CompanionAvailability editable /><CompanionEnquiriesTable /></> : <CompanionProfileSettings
      profileSettings={profileSettings} updateProfileAttr={updateProfileAttr}
      toggleService={(value) => toggle("services_offered", value)}
      toggleFetish={(value) => toggle("fetishes_offered", value)}
      setProfileSettings={setProfileSettings} saveProfileSettings={saveProfileSettings}
      settingsLoading={settingsLoading}
    />}
  </div></AppLayout>;
}
